<template>
  <transition name="slide" mode="out-in">
    <ModalWindow
      :extraClasses="'add-option-modal'"
      v-if="showModal"
      @close="cancelModal"
      :closeBtnText="'Cancel'"
      :showCloseIcon="true"
      :showCloseBtn="false"
    >
      <template slot="modal-title">Email This Job</template>
      <template slot="body">
        <validation-observer v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit(onSubmit)" class="email-job-form">
            <ValidationProvider
              vid="subject"
              name="Subject"
              rules="required|min:3|max:250"
              v-slot="{ errors }"
              tag="div"
              class="input-wrapper form-group"
            >
              <label for="subject">
                Subject:
                <span class="required">*</span>
              </label>
              <input
                id="subject"
                type="text"
                placeholder="Subject"
                v-model="model.subject"
                :class="{'input-error':errors.length}"
                autocomplete="off"
              />
              <div class="invalid-feedback">{{ errors[0] }}</div>
            </ValidationProvider>

            <ValidationProvider
              vid="email"
              name="email"
              rules="required|min:3|max:250"
              v-slot="{ errors }"
              tag="div"
              class="input-wrapper form-group"
            >
              <label for="email">
                Email:
                <span class="required">*</span>
              </label>
              <input
                id="email"
                type="text"
                placeholder="Email"
                v-model="model.email"
                :class="{'input-error':errors.length}"
                autocomplete="off"
              />
              <div class="invalid-feedback">{{ errors[0] }}</div>
            </ValidationProvider>

            <ValidationProvider
              vid="message"
              name="message"
              rules="required|min:3|max:800"
              v-slot="{ errors }"
              tag="div"
              class="input-wrapper form-group"
            >
              <label for="message">
                Message:
                <span class="required">*</span>
              </label>
              <textarea
                id="message"
                placeholder="Message"
                rows="6"
                v-model="model.message"
                :class="{'input-error':errors.length}"
                autocomplete="off"
              ></textarea>
              <div class="invalid-feedback" v-if="errors.length">{{ errors[0] }}</div>
              <div
                class="typo-light small"
              >The job URL will be automatically attached with the email content.</div>
            </ValidationProvider>

            <button class="primary-btn btn-mid" type="submit">Send Now</button>
          </form>
        </validation-observer>
      </template>
    </ModalWindow>
  </transition>
</template>

<script>
const Swal = require("sweetalert2");

export default {
  props: ["EventshowModal", "emailUrl", "jobTitle"],
  data() {
    return {
      showModal: false,
      model: {},
      is_submitted: false,
    };
  },
  components: {
    ModalWindow: require("@/components/global/Modal").default,
  },
  watch: {
    EventshowModal: {
      handler: function (model) {
        this.showModal = model;
      },
      immediate: true,
    },
    jobTitle: {
      handler: function (model) {},
      immediate: true,
    },
  },
  created() {
    this.model.subject = "Job Title : " + this.jobTitle;
  },
  methods: {
    cancelModal: function () {
      this.$parent.showModal = false;
      this.model = {};
      this.$nextTick(() => this.$refs.form.reset());
      this.model.subject = "Job Title : " + this.jobTitle;
    },
    onSubmit() {
      var _this = this;
      axios
        .post(this.emailUrl, this.model)
        .then((response) => {
          this.cancelModal();
          this.promptSuccess();
        })
        .catch((error) => {
          if (error.response.status == 422) {
            this.server_errors = error.response.data.errors;
            this.error_message = error.response.data.message;
            this.$refs.form.setErrors(error.response.data.errors);
          } else {
            this.$throwSwalError(error);
          }
        })
        .then(function () {
          _this.is_submitted = false;
        });
    },
    promptSuccess: function () {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "The job link has been sent!",
        showConfirmButton: false,
        timer: 1500,
      });
    },
  },
};
</script>


